import config from '@/config';

export const frequencyInfoUrl = 'https://www.frequency.xyz/#users';
export const frequencyCallbackPagePath =
  (process.env.NODE_ENV === 'production' ? config.webappDomain : 'http://localhost:3000') +
  '/frequency';
export const frequencyFeatureFlagName = 'Frequency';
